// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__CByhd","header":"MergedInvoice_header__qvfxX"};